import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { TablePagination } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import GetAppIcon from '@material-ui/icons/GetApp';

export default function EnhancedTablePagination(props) {
  const { count, rowsPerPage, rowsPerPageOptions, page, onChangeRowsPerPage, onChangePage, onExportClicked, allowExport } = props;

  return (
    <>
    {
      allowExport ?
        <TablePagination
          ActionsComponent={(subProps) => <TablePaginationActions {...subProps} onExportClicked={onExportClicked}/>}            
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        /> :
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      }
      </>
  );
};

EnhancedTablePagination.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onExportClicked: PropTypes.func.isRequired,
  onChangeRowsPerPage: PropTypes.func.isRequired,
  allowExport: PropTypes.bool
};


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage, onExportClicked } = props;

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleExportClicked = _ => {
      onExportClicked();
  };

  return (
    <Toolbar>
      <IconButton onClick={handleBackButtonClick} 
        disabled={page === 0} 
        aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page">
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        disabled={count === 0} 
        onClick={handleExportClicked}
        aria-label="download to CSV">
        <GetAppIcon></GetAppIcon>
      </IconButton>
    </Toolbar>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onExportClicked: PropTypes.func.isRequired
};